import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { GenericTableModule } from "../../generic-table/generic-table.module";
import { VendorsModalComponent } from "./vendors-dialog.component";

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        ReactiveFormsModule,
        GenericTableModule
    ],
    declarations: [
        VendorsModalComponent
    ],
    exports: [
        VendorsModalComponent
    ]
})
export class VendorsDialogModule { }
